export default {
	data(){
		return {
			tableGBoptions: { 
				options: {editar: 'Editar usuario', inactivar: 'Inactivar usuario'},
				modals: []
			},

			tableGBSearch: ['datos_pacientes/documento','datos_pacientes/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Nombre', sort: null, sortTable: 'datos_pacientes/name'},
					tbody: { td: ['datos_pacientes/name']}
				},
				{
					thead: { th: 'Documento', sort: null, sortTable: 'datos_pacientes/documento'},
					tbody: { td: ['datos_pacientes/documento'],}
				},
				{
					thead: { th: 'Direccion', },
					tbody: { td: ['datos_pacientes/direccion'],}
				},
				{
					thead: { th: 'Telefonos', },
					tbody: { td: ['datos_pacientes/telefonos'],}
				},
				{
					thead: { th: 'Historia', },
					tbody: { table: {
						value: false,
						tabla: "info_orden",
						search: [
						  "fecha_entrega"
						],
						options: {
						  garantia: {
							  icon: "arrow-clockwise",
							  btn: "Registrar",
							  ftn: "garantiaFtn",
							  msj: "Registrar Garantia",
							  variant: "success",
							  inputs: [ 'info_garantia/garantia'],
							}
						},
						items: [
							{
							  thead: { th: "# Orden" },
							  tbody: { td: [ "consecutivo" ]}
							},
							{
								thead: { th: "Fecha entrega" },
								tbody: { td: [ "fecha_entrega" ]}
							},
							{
								thead: { th: "Exámen"},
								tbody: { td: [ "id_info_examens" ], link: '/api/pdf/examen' }
							},
							{
								thead: { th: "Diagnostico"},
								tbody: { td: [ "id" ], link: '/api/pdf/diagnosticos' }
							},
							{
								thead: { th: "Orden"},
								tbody: { td: [ "id" ], link: '/api/pdf/orden_venta' }
							}
						]
					  }
					}
				},
				{
					thead: { th: 'Garantias', },
					tbody: { table: {
						value: false,
						tabla: "info_garantia",
						search: [
						  "fecha_entrega"
						],
						items: [
							{
							  thead: { th: "Orden #" },
							  tbody: { td: [ "id_info_orden" ]}
							},
							{
								thead: { th: "Exámen"},
								tbody: { td: [ "id" ], link: '/api/pdf/garantia_examen' }
							},
							{
								thead: { th: "Diagnostico"},
								tbody: { td: [ "id" ], link: '/api/pdf/garantia_diagnosticos' }
							},
							{
								thead: { th: "Orden"},
								tbody: { td: [ "id" ], link: '/api/pdf/garantia_orden_venta' }
							}
						]
					  }
					}
				},
			]						
		}
	},
}